import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import './Add_User.css';
import Footer from './Footer.js';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from "./Constants.js";
import { BASE_URL1 } from "./Constants.js";


const AddIndent = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userType, setUserType] = useState('employee');
  const [areas, setAreas] = useState([]);
  const [dressTypes, setDressTypes] = useState([]);
  const [uniformGenderType, setUniformGenderType] = useState([]);
  const [dressSizes, setDressSizes] = useState([]);
  const [dressColors, setDressColors] = useState([]);
  const [newUser1, setNewUser1] = useState({ emp_det: '' });
  const [suggestions, setSuggestions] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [city, setCity] = useState('');
  const [user, setUser] = useState([]);
  const [rows, setRows] = useState([{
    area_id: '',
    uniform_type: '',
    uniform_size: '',
    uniform_color: '',
    sizes: [],
    dressColors: [],
    uniform_qty: 0,
    cost: 0,
    costk: 0,
    available_qty: 0,

  }]);

  const handleInputChange2 = async (e) => {
    const { name, value } = e.target;
    setNewUser({ ...newUser, [name]: value });

    if (name === 'gender') {
      fetchUniformTypesByGender(value);
    }
  };


  const handleInputChange = async (e) => {
    const value = e.target.value;
    setNewUser({ ...newUser1, emp_det: value });

    // Update the state dynamically based on field name
    // setNewUser((prevUser) => ({
    //   ...prevUser,
    //   [name]: value,
    // }));

    if (value.length > 1) {
      try {
        const response = await fetch(`${BASE_URL}autocomplete-new_emp_master?q=${value}`);
        const data = await response.json();

        // Ensure data is always an array
        const suggestionsArray = Array.isArray(data) ? data : [data];
        setSuggestions(suggestionsArray);
      } catch (error) {
        console.error("Autocomplete fetch error:", error);
      }
    } else {
      setSuggestions([]);
    }
  };

  const handleInputChange1 = async (e) => {
    const { name, value } = e.target;
    setNewUser(prev => ({ ...prev, [name]: value }));


  };


  const [totalCost, setTotalCost] = useState(0);

  const handleUserTypeChange = (e) => {
    const selectedType = e.target.value;
    setUserType(selectedType);

    //Optional: Navigate immediately when changed
    navigate(selectedType === 'employee' ? '/add_indent' : '/add_candidate_indent');
  };


  const [newUser, setNewUser] = useState({
    emp_det: '',
    candidate_name_det: '',
    mobile: '',
    doj: '',
    gender: '',
    department: '',
    location: '',
    payment_mode: 'QR',
  });

  const [formError, setFormError] = useState(null);
  const navigate = useNavigate();

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setNewUser({
  //     ...newUser,
  //     [name]: value,
  //   });
  // };

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    console.log(token); // for debugging
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        setUser(data.profile.is_uniform_access_given); // Assuming the response contains the user profile info
        setCity(data.profile.city);
      } catch (error) {
        setError(error.message); // Handle errors
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false); // Set loading to false after data fetch completes
      }
    };

    fetchProfile();
  }, []);

  useEffect(() => {
    
      if (!city) return; // wait until city is loaded
    
      const fetchAreas = async () => {
        try {
          const token = localStorage.getItem('authToken');
    
          const response = await fetch(`${BASE_URL}areas`, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          });
    
          const data = await response.json();
    
          if (data && data.areas) {
    
            const activeAreas = data.areas.filter(
              area =>
                area.status === 'A' &&
                area.area.toLowerCase().includes(city.toLowerCase())
            );
    
            setAreas(activeAreas);
          }
    
        } catch (err) {
          setError(err.message);
        }
      };
    
      fetchAreas();
    
    }, [city]); // 🔴 IMPORTANT

  useEffect(() => {
    const fetchDressTypes = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_types`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        const data = await response.json();
        if (data && data.dressTypes) {
          const activeDressTypes = data.dressTypes.filter(type => type.status === 'A');
          setDressTypes(activeDressTypes);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDressTypes();
  }, []);

  useEffect(() => {
    const fetchDressSizes = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${BASE_URL}dress_sizes`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        const data = await response.json();
        if (data && data.dressSizes) {
          const activeDressSizes = data.dressSizes.filter(size => size.status === 'A');
          setDressSizes(activeDressSizes);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDressSizes();
  }, []);

  useEffect(() => {
    const fetchDressColors = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${BASE_URL}dress_colors`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });
        const data = await response.json();
        if (data && data.dressColors) {
          const activeDressColors = data.dressColors.filter(color => color.status === 'A');
          setDressColors(activeDressColors);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDressColors();
  }, []);

  const handleColorChange = async (e, index) => {
    const colorId = e.target.value;
    const updatedRows = [...rows];
    console.log("checks", updatedRows);
    updatedRows[index].uniform_color = colorId;

    setRows(updatedRows);

    const { uniform_type, dress_size_id, area_id } = updatedRows[index]; // ✅ safer than rows[index]

    if (colorId && uniform_type && dress_size_id) {
      try {
        const token = localStorage.getItem('authToken');
        const formData = new FormData();
        formData.append('area_id', area_id);
        formData.append('type_id', uniform_type);
        formData.append('size_id', dress_size_id);
        formData.append('color_id', colorId);

        const response = await fetch(`${BASE_URL}get_cost`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
          body: formData,
        });

        const data = await response.json();

        if (data && data.cost) {
          updatedRows[index].cost = 0;
          updatedRows[index].costk = data.cost;
          updatedRows[index].available_qty = data.qty || 0;

          setRows([...updatedRows]);
          calculateTotalCost(updatedRows);
        } else {
          console.log("Cost not available.");
        }
      } catch (err) {
        setError('Failed to fetch cost');
        console.error(err);
      }
    }
  };


  const calculateTotalCost = (updatedRows) => {
    const total = updatedRows.reduce((acc, row) => {
      if (row.uniform_qty > 0) {  // Only sum up rows where quantity is greater than 0
        return acc + (row.cost);
      }
      return acc;
    }, 0);
    setTotalCost(total);
  };

  const handleQtyChange = (index, e) => {
    const value = parseInt(e.target.value, 10);
    const updatedRows = [...rows];
    const availableQty = parseInt(updatedRows[index].available_qty || 0, 10);

    if (value > availableQty) {
      alert("Entered quantity exceeds available quantity!");
      return; // Don't update state
    }

    // if (value > availableQty) {
    //   alert("Entered quantity exceeds available quantity!");
    //   return; // Don't update state
    // }
    const newQty = e.target.value;

    if (!isNaN(newQty) && newQty >= 0) {
      const updatedRows = [...rows];
      updatedRows[index].uniform_qty = parseInt(newQty, 10);

      const unitCost = updatedRows[index].costk;
      if (unitCost) {
        updatedRows[index].cost = newQty * unitCost;
      }

      setRows(updatedRows);
      calculateTotalCost(updatedRows);
    }
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        area_id: '',
        uniform_type: '',
        uniform_size: '',
        uniform_color: '',
        uniform_qty: 0,
        cost: 0,
      },
    ]);
  };

  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
    calculateTotalCost(updatedRows);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;


  const fetchUniformTypesByGender = async (gender) => {
    const token = localStorage.getItem('authToken');

    try {
      const response = await fetch(`${BASE_URL}get_gender_by_uniform`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ gender }),
      });

      const result = await response.json();

      if (result.status && result.dressType) {
        setUniformGenderType(result.dressType);
      } else {
        setUniformGenderType([]);
        console.error('No dress types found for selected gender');
      }
    } catch (err) {
      console.error('Error fetching dress types:', err);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('user_type', userType);
      formData.append('candidate_name', newUser.emp_det);
      formData.append('mobile', newUser.mobile);
      formData.append('date_of_join', newUser.doj);
      formData.append('department', newUser.department);
      formData.append('location', newUser.location);
      formData.append('gender', newUser.gender);
      formData.append('cost', totalCost);
      formData.append('costk', totalCost);
      // formData.append('payment_mode', newUser.payment_mode);
      formData.append('payment_mode', 'QR');



      rows.forEach((row, index) => {
        Object.keys(row).forEach(key => {
          formData.append(`rows[${index}][${key}]`, row[key]);
        });
      });
      console.log("check_rows", rows);

      const response = await fetch(`${BASE_URL}add_indent`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to add candidate');
      }
      const resData = await response.json();

      const insertedId = resData.inserted_id;
      const encodedId = btoa(insertedId);
      if (newUser.payment_mode === 'Gateway') {
        window.location.href = `/manage_indent`;
       // window.location.href = `${BASE_URL1}payment/initiatePayment.php?id=${encodedId}`;
      } else {
        window.location.href = `/manage_indent`;
      }
      // Ensure backend sends this
      // window.location.href = `${BASE_URL1}payment/initiatePayment.php?id=${encodedId}`;
      //navigate(`/qr_code/${insertedId}`);
      //navigate('/qr_code');
    } catch (err) {
      setFormError(err.message);
    }
  };
  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

    const isSubmitDisabled =
    submitting || rows.some((row) => Number(row.cost) <= 0);

  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div
        className="page-container"
        style={{
          marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '250px' : '0',
          transition: 'margin-left 0.3s ease',
        }}
      >
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="card add-user-card">
                    <div className="card-header">
                      <h2>Issue Uniform</h2>
                      {/* <Link to={`/qr_code/${insertedId}`} className="btn btn-primary">
  Go to QR Page
</Link> */}
                      <div className="d-flex align-items-center mb-3">
                        <label className="mr-3 font-weight-bold">Select Type:</label>

                        <div className="form-check mr-3">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="userType"
                            id="employeeRadio"
                            value="employee"
                            checked={userType === 'employee'}
                            onChange={handleUserTypeChange}  // <-- ADD THIS
                            selected
                          />
                          <label className="form-check-label" htmlFor="employeeRadio">
                            Employee
                          </label>
                        </div>

                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="userType"
                            id="candidateRadio"
                            value="candidate"
                            checked={userType === 'candidate'}
                            onChange={handleUserTypeChange} // <-- ADD THIS
                          />
                          <label className="form-check-label" htmlFor="candidateRadio">
                            Candidate
                          </label>
                        </div>
                      </div>

                    </div>
                    <div className="card-body">
                      <form onSubmit={handleSubmit} method="post" acceptCharset="utf-8">
                        {formError && <div className="alert alert-danger">{formError}</div>}

                        <div className='row'>
                          <div className='col-md-3'>
                            <div className="form-group position-relative">
                              <label htmlFor="candidate_name"><b>Employee Id</b></label>
                              <input
                                type="text"
                                id="candidate_name"
                                name="candidate_name"
                                className="form-control"
                                value={newUser.emp_det}
                                onChange={handleInputChange}
                                autoComplete="off"
                              />

                              {suggestions.map((item, index) => (
                                <li
                                  key={index}
                                  className="list-group-item list-group-item-action"
                                  onClick={() => {
                                    const updatedUser = {
                                      ...newUser,
                                      emp_det: `${item.emp_code} - ${item.comp_name}`,
                                      candidate_name_det: item.comp_name,
                                      department: item.dept_name || '',
                                      location: item.location_name || '',
                                      doj: item.doj || '',
                                      mobile: item.mobile || '',
                                      gender: item.gender || '',

                                    };

                                    setNewUser(updatedUser);
                                    setSuggestions([]);
                                    fetchUniformTypesByGender(item.gender);
                                  }}
                                  style={{ cursor: 'pointer' }}
                                >
                                  {item.comp_name} - {item.emp_code}
                                </li>
                              ))}
                            </div>
                          </div>
                          <div className='col-md-3'>
                            <div className="form-group">
                              <label htmlFor="candidate_name"><b>Employee Name</b></label>
                              <input
                                type="text"
                                id="candidate_name_det"
                                name="emp_det"
                                className="form-control"
                                value={newUser.emp_det}

                              />
                            </div>

                          </div>
                          <div className='col-md-3'>
                            <div className="form-group">
                              <label htmlFor="mobile"><b>Mobile</b></label>
                              <input
                                type="text"
                                id="mobile"
                                name="mobile"
                                className="form-control"
                                value={newUser.mobile}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d{0,10}$/.test(value)) {
                                    handleInputChange1(e); // allow only digits up to 10
                                  }
                                }}
                                maxLength="10"
                                readOnly={newUser.mobile !== ''}
                                title="Please enter a 10-digit mobile number"
                              />
                            </div></div>
                          <div className='col-md-3'>
                            <div className="form-group">
                              <label htmlFor="mobile"><b>Date Of Joining</b></label>
                              <input
                                type="date"
                                id="mobile"
                                name="doj"
                                className="form-control"
                                value={newUser.doj}
                                onChange={handleInputChange1}
                                pattern="\d{10}"
                                maxLength="10"
                                readOnly
                                title="Please enter a 10-digit mobile number"
                              />
                            </div></div>

                        </div>
                        <div className='row'>
                          <div className='col-md-4'>
                            <div className="form-group">
                              <label htmlFor="department"><b>Department</b></label>
                              <input
                                type="text"
                                id="department"
                                name="department"
                                className="form-control"
                                value={newUser.department}
                                onChange={handleInputChange} readOnly
                              />
                            </div></div>
                          <div className='col-md-4'>
                            <div className="form-group">
                              <label htmlFor="location"><b>Location</b></label>
                              <input
                                type="text"
                                id="location"
                                name="location"
                                className="form-control"
                                value={newUser.location}
                                onChange={handleInputChange} readOnly
                              />
                            </div></div>
                          <div className='col-md-4'>
                            <div className="form-group">
                              <label htmlFor="gender"><b>Gender</b></label>
                              <select
                                id="gender"
                                name="gender"
                                className="form-control"
                                value={newUser.gender}
                                readOnly
                                onChange={handleInputChange2}
                              >
                                <option value="">Select Gender</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                              </select>
                            </div></div></div>
                        <div className="col-md-4 text-end">
                          <button
                            type="button"
                            className="btn btn-success"
                            onClick={handleAddRow}
                          >
                            Add Uniform
                          </button>
                        </div>

                        <div className="row">
                          <div className="col-md-2">
                            <div className="form-group">
                              <label ><b>Stores</b></label>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="form-group">
                              <label ><b>Type</b></label>
                            </div>
                          </div>
                          <div className="col-md-1">
                            <div className="form-group">
                              <label><b>Size</b></label>
                            </div> </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <label ><b>Colour</b></label>
                            </div></div>

                          <div className="col-md-1">
                            <div className="form-group">
                              <label ><b>Unit Cost</b></label>
                            </div>       </div>
                          <div className="col-md-1">
                            <div className="form-group">
                              <label ><b>Avl Qty</b></label>
                            </div>       </div>
                          <div className="col-md-1">
                            <div className="form-group">
                              <label ><b>Req Qty</b></label>
                            </div>       </div>

                          <div className="col-md-2">
                            <div className="form-group">
                              <label><b>Total</b></label>
                            </div></div>


                        </div>

                        {rows.map((row, index) => (
                          <div className="row" key={index}>
                            <div className="col-md-2">
                              <div className="form-group">

                                <select
                                  id={`area_id_${index}`}
                                  name="area_id"
                                  className="form-control"
                                  value={row.area_id}
                                  onChange={(e) => {
                                    const updatedRows = [...rows];
                                    updatedRows[index].area_id = e.target.value;
                                    updatedRows[index].cost = 0;  // Reset cost when type changes
                                    setRows(updatedRows);
                                  }}
                                >
                                  <option value="">Select Area</option>
                                  {areas.map((area) => (
                                    <option key={area.id} value={area.id}>
                                      {area.area}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">

                                <select
                                  id={`uniform_type_${index}`}
                                  name="uniform_type"
                                  className="form-control"
                                  value={row.uniform_type}
                                  onChange={async (e) => {
                                    const selectedType = e.target.value;
                                    const updatedRows = [...rows];
                                    updatedRows[index].uniform_type = selectedType;
                                    updatedRows[index].uniform_size = '';
                                    updatedRows[index].cost = 0;
                                    updatedRows[index].dress_size_id = '';
                                    updatedRows[index].sizes = [];

                                    // Call API to get sizes
                                    try {
                                      const token = localStorage.getItem('authToken');
                                      const response = await fetch(`${BASE_URL}/dress_sizes_by_type`, {
                                        method: 'POST',
                                        headers: {
                                          'Authorization': `Bearer ${token}`,
                                          'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify({ type_id: selectedType })
                                      });

                                      const data = await response.json();
                                      if (data.status && Array.isArray(data.dressTypes)) {
                                        updatedRows[index].sizes = data.dressTypes;
                                      } else {
                                        updatedRows[index].sizes = [];
                                      }
                                    } catch (error) {
                                      console.error('Error fetching dress sizes:', error);
                                      updatedRows[index].sizes = [];
                                    }

                                    setRows(updatedRows);
                                  }}
                                >
                                  <option value="">Select Uniform Type</option>
                                  {uniformGenderType.map((dressType) => (
                                    <option key={dressType.id} value={dressType.id}>
                                      {dressType.dress_type}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-1">
                              <div className="form-group">

                                <select
                                  className="form-control"
                                  name="dress_size_id"
                                  value={row.dress_size_id}
                                  onChange={async (e) => {
                                    const selectedSize = e.target.value;
                                    const updatedRows = [...rows];
                                    updatedRows[index].dress_size_id = selectedSize;
                                    updatedRows[index].uniform_size = selectedSize;
                                    updatedRows[index].uniform_color = '';
                                    updatedRows[index].dressColors = [];

                                    const payload = {
                                      dress_size_id: selectedSize,
                                      dress_type_id: updatedRows[index].uniform_type,
                                      gender: newUser.gender // or 'Female', adjust as needed
                                    };

                                    try {
                                      const token = localStorage.getItem('authToken');
                                      const response = await fetch(`${BASE_URL}/dress_colors_by_size`, {
                                        method: 'POST',
                                        headers: {
                                          'Authorization': `Bearer ${token}`,
                                          'Content-Type': 'application/json'
                                        },
                                        body: JSON.stringify(payload)
                                      });

                                      const data = await response.json();
                                      if (data.status && Array.isArray(data.dressTypes)) {
                                        updatedRows[index].dressColors = data.dressTypes;
                                      } else {
                                        updatedRows[index].dressColors = [];
                                      }
                                    } catch (err) {
                                      console.error("Error fetching colors:", err);
                                      updatedRows[index].dressColors = [];
                                    }

                                    setRows(updatedRows);
                                  }}
                                >
                                  <option value="">Select Uniform Size</option>
                                  {row.sizes?.map((size) => (
                                    <option key={size.id} value={size.id}>
                                      {size.dress_size}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-2">
                              <div className="form-group">

                                <select
                                  id={`uniform_color_${index}`}
                                  name="uniform_color"
                                  className="form-control"
                                  value={row.uniform_color}
                                  onChange={(e) => handleColorChange(e, index)} // ✅ call your function
                                >
                                  <option value="">Select Uniform Color</option>
                                  {row.dressColors?.map((color) => (
                                    <option key={color.id} value={color.id}>
                                      {color.dress_color}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-1">
                              <div className="form-group">

                                <input
                                  type="text"
                                  className="form-control"
                                  value={row.costk || 0}
                                  disabled
                                />
                              </div>
                            </div>
                            <div className="col-md-1">
                              <div className="form-group">
                                <input
                                  type="number"
                                  className="form-control"
                                  value={row.available_qty || 0}
                                  disabled
                                />
                              </div>
                            </div>
                            <div className="col-md-1">
                              <div className="form-group">

                                <input
                                  type="number"
                                  min="1"
                                  className="form-control"
                                  id={`uniform_qty_${index}`}
                                  name="uniform_qty"
                                  value={row.uniform_qty}
                                  onChange={(e) => handleQtyChange(index, e)}

                                />
                              </div>
                            </div>

                            <div className="col-md-1">
                              <div className="form-group">

                                <input
                                  type="text"
                                  className="form-control"
                                  value={row.cost || 0}
                                  disabled
                                />
                              </div>
                            </div>
                            <div className="col-md-1">
                              {/* <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => handleRemoveRow(index)}
                              >
                                Remove
                              </button> */}

                              <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => handleRemoveRow(index)}
                              >
                                <i className="fas fa-trash-alt"></i> {/* Font Awesome delete icon */}
                              </button>


                            </div>
                          </div>
                        ))}
                        <div className="card-footer">
                          {totalCost > 0 ? (
                            <h4>Total Cost: {totalCost}</h4>
                          ) : (
                            <h4>Total Cost: 0</h4>
                          )}
                        </div>
                        <div className='col-md-3'>
                          <select className='form-control' name="payment_mode" id="payment_mode" value={newUser.payment_mode} required
                            onChange={handleInputChange2}>
                            <option value="">Payment Mode</option>
                            <option value="QR">QR</option>
                            <option value="Gateway">Gateway</option>
                          </select>
                        </div>
                        <br />
                        <button type="submit" className="btn btn-primary" disabled={isSubmitDisabled}>
                          {submitting ? 'Submitting...' : 'Submit'}
                        
                        </button>
                      </form>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AddIndent;
